import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '../../../../../Flex';
import CommissionPointsAndPrice from '../../../../../CommissionPointsAndPrice';
import s from './FolderPanel.scss';
var FolderPanel = function (_a) {
    var _b;
    var folder = _a.folder, price = _a.price, dollarsCost = _a.dollarsCost;
    var t = useTranslation().t;
    var subscribers = (_b = folder.premiumFolderData) === null || _b === void 0 ? void 0 : _b.numSubscribers;
    return (React.createElement(Flex, { className: s['root'], alignItems: "center" },
        React.createElement("div", { className: s['left'] },
            React.createElement("div", { className: s['title'], title: folder.name }, folder.name),
            React.createElement("div", { className: s['stats'] },
                t('folderCard.stats.artworks', {
                    count: folder.size,
                }),
                React.createElement("span", { className: s['stats-separator'] }, "|"),
                t('folderCard.stats.subscribers', {
                    count: subscribers,
                }))),
        React.createElement("div", { className: s['price-wrapper'] },
            React.createElement(CommissionPointsAndPrice, { points: price, price: dollarsCost }))));
};
FolderPanel.displayName = 'FolderPanel';
export default FolderPanel;
//# sourceMappingURL=FolderPanel.js.map